<template>
  <div>
    <v-card
      style="width:100%;"
      class="d-flex justify-center"
      v-if="!showMobileView"
    >
      <v-layout
        class="d-flex justify-center align-center pr-4"
        style="height:80px; width: 100%;"
      >
        <div class="d-flex align-center pl-5" style="width:100%; height:80px;">
          <h4
            style="color:gray; padding-right:4px;"
            @click="goBack()"
            class="go-back"
          >
            {{ groupLabel }} >
          </h4>
          <h4 class="text-capitalize" id="group-name-breadcrumb">
            {{ _details.group_name }}
          </h4>
        </div>
      </v-layout>
    </v-card>
    <div class="d-flex justify-center mt-6">
      <group-detail-card
        :style="!showMobileView ? 'width: calc(90% + 32px)' : ''"
      />
    </div>
    <div :class="!showMobileView ? 'd-flex justify-center ma-0' : ''">
      <network-health class="flex-grow-0" />
      <network-health-notifications />
      <div
        class="d-flex flex-column flex-shrink-0"
        :style="!showMobileView ? 'width: 30%' : ''"
      >
        <brightness v-if="_currentClient.client_name !== 'shark'" />
        <screen-shot-report />
      </div>
    </div>
    <unit-group-locations />
    <UpdateSnackbar />
  </div>
</template>
<script>
import { mapActions, mapMutations, mapGetters } from 'vuex';
import _ from 'lodash';
import NetworkHealth from '@/components/group-details/NetworkHealth';
import GroupDetailCard from '@/components/group-details/GroupDetailCard';
import UnitGroupLocations from '@/components/group-details/UnitGroupLocations';
import ScreenShotReport from '@/components/group-details/ScreenShotReport';
import NetworkHealthNotifications from '@/components/group-details/NetworkHealthNotifications';
import Brightness from '@/components/group-details/Brightness';
import UpdateSnackbar from '@/components/group-details/UpdateSnackbar';
import { MobileView } from '@/mixins';
import GroupDetailData from '@/mixins/GroupDetailData';
import router from '../router';

export default {
  components: {
    GroupDetailCard,
    NetworkHealth,
    UnitGroupLocations,
    NetworkHealthNotifications,
    Brightness,
    ScreenShotReport,
    UpdateSnackbar,
  },
  mixins: [MobileView, GroupDetailData],
  data() {
    return {
      detailsLoaded: false,
    };
  },
  methods: {
    ...mapActions({
      _acquireDetails: 'groupDetails/acquireDetails',
      _getAllUsers: 'account/getAllUsers',
      _getAdminsAndUsers: 'account/getAdminsAndUsers',
      _updateDetails: 'groupDetails/updateDetails',
    }),
    ...mapMutations({
      _setDeails: 'groupDetails/setDetails',
      _setUserType: 'account/setUserType',
    }),
    goBack() {
      router.push(
        `/${this._currentClient.client_name
          .toLowerCase()
          .replace(/\s/g, '')}/groups`
      );
    },
  },
  computed: {
    ...mapGetters({
      _details: 'groupDetails/getDetails',
      _updating: 'groupDetails/getUpdateInProgress',
      _currentClient: 'account/getCurrentClient',
      _clientIsSet: 'account/getClientIsSet',
    }),
    details: {
      get() {
        return this._details;
      },
      set(val) {
        this._setDetails(val);
      },
    },
    groupLabel() {
      if (this._currentClient.client_name != 'shark') {
        return 'Groups';
      }
      return 'Courses';
    },
  },
  mounted() {
    this._getAdminsAndUsers();
    window.scrollTo(0, 0);
    if (this._currentClient.table_name) {
      this._acquireDetails(this.$route.params.id);
    }
    this.throttledMethod = _.debounce(() => {
      this._updateDetails();
    }, 1000);
  },
  watch: {
    details: {
      handler() {
        if (!this._updating && this.detailsLoaded) {
          this.throttledMethod();
        } else {
          this.detailsLoaded = true;
        }
      },
      deep: true,
    },
    _clientIsSet() {
      if (this._clientIsSet) {
        this._acquireDetails(this.$route.params.id);
      }
    },
  },
};
</script>

<style>
.go-back:hover {
  cursor: pointer;
}
</style>
